// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Confirmation_stepTitle__jEs0N {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--primary-dark-blue);
  margin-bottom: 15px;
  text-align: center;
}

.Confirmation_formContent__Yf\\+q0 {
  min-height: 450px;
}

.Confirmation_accordionGroup__KcMRs {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
}

.Confirmation_noLineItems__ajHN7 {
  color: #777;
  font-style: italic;
}

.Confirmation_lineItemList__Cso2g {
  list-style: none;
  padding: 0;
  margin: 0;
}

.Confirmation_lineItem__dzCeK {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-radius: 6px;
  background-color: #f9f9f9;
  margin-bottom: 8px;
}

.Confirmation_lineItemName__QVXbJ {
  font-weight: 500;
}

.Confirmation_lineItemDetails__7VxgI {
  color: #555;
  text-align: right;
}

.Confirmation_grandTotal__VUzCz {
  font-weight: bold;
  margin-top: 10px;
  border-top: 2px solid #eee;
  padding-top: 10px;
  background-color: #f0f4f8;
}

/* Primary CTA — matches the nav Continue / Add User / Save buttons */
.Confirmation_submitButton__GsxbO {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: fit-content;
  margin: 0 auto;
  min-height: 44px;
  padding: 0 32px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--neutral-white);
  background-color: var(--secondary-bright-blue);
  border: 1px solid var(--secondary-bright-blue);
}

.Confirmation_submitButton__GsxbO:hover:not(:disabled) {
  background-color: var(--primary-dark-blue);
  border-color: var(--primary-dark-blue);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.Confirmation_submitButton__GsxbO:disabled,
.Confirmation_submitButton__GsxbO:disabled:hover {
  background-color: #cbd3dd;
  border-color: #cbd3dd;
  cursor: not-allowed;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/RegistrationForm/steps/Confirmation/Confirmation.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".stepTitle {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.formContent {\n  min-height: 450px;\n}\n\n.accordionGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.noLineItems {\n  color: #777;\n  font-style: italic;\n}\n\n.lineItemList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.lineItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 15px;\n  border-radius: 6px;\n  background-color: #f9f9f9;\n  margin-bottom: 8px;\n}\n\n.lineItemName {\n  font-weight: 500;\n}\n\n.lineItemDetails {\n  color: #555;\n  text-align: right;\n}\n\n.grandTotal {\n  font-weight: bold;\n  margin-top: 10px;\n  border-top: 2px solid #eee;\n  padding-top: 10px;\n  background-color: #f0f4f8;\n}\n\n/* Primary CTA — matches the nav Continue / Add User / Save buttons */\n.submitButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: fit-content;\n  margin: 0 auto;\n  min-height: 44px;\n  padding: 0 32px;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--neutral-white);\n  background-color: var(--secondary-bright-blue);\n  border: 1px solid var(--secondary-bright-blue);\n}\n\n.submitButton:hover:not(:disabled) {\n  background-color: var(--primary-dark-blue);\n  border-color: var(--primary-dark-blue);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.submitButton:disabled,\n.submitButton:disabled:hover {\n  background-color: #cbd3dd;\n  border-color: #cbd3dd;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepTitle": `Confirmation_stepTitle__jEs0N`,
	"formContent": `Confirmation_formContent__Yf+q0`,
	"accordionGroup": `Confirmation_accordionGroup__KcMRs`,
	"noLineItems": `Confirmation_noLineItems__ajHN7`,
	"lineItemList": `Confirmation_lineItemList__Cso2g`,
	"lineItem": `Confirmation_lineItem__dzCeK`,
	"lineItemName": `Confirmation_lineItemName__QVXbJ`,
	"lineItemDetails": `Confirmation_lineItemDetails__7VxgI`,
	"grandTotal": `Confirmation_grandTotal__VUzCz`,
	"submitButton": `Confirmation_submitButton__GsxbO`
};
export default ___CSS_LOADER_EXPORT___;
